import { defineMessages } from 'react-intl';

export default defineMessages({
    claimDetailNumber: {
        id: 'portal.claim.views.claim-detail.Claim Details',
        defaultMessage: 'Claim Details'
    },
    summaryTab: {
        id: 'portal.claim.views.claim-detail.Details',
        defaultMessage: 'Details'
    },
    notesTab: {
        id: 'portal.claim.views.claim-detail.Notes',
        defaultMessage: 'Notes'
    },
    documentsTab: {
        id: 'portal.claim.views.claim-detail.Documents',
        defaultMessage: 'Documents'
    },
    paymentsTab: {
        id: 'portal.claim.views.claim-detail.Payments',
        defaultMessage: 'Payments'
    },
    servicesTab: {
        id: 'portal.claim.views.claim-detail.Services',
        defaultMessage: 'Services'
    },
    policyNumberClaimDetail: {
        id: 'portal.claim.views.claim-detail.Policy',
        defaultMessage: 'Policy'
    },
    policyStatus: {
        id: 'portal.claim.views.claim-detail.Status',
        defaultMessage: 'Status'
    },
    reportedBy: {
        id: 'portal.claim.views.claim-detail.Reported By',
        defaultMessage: 'Reported By'
    },
    accountNumber: {
        id: 'portal.claim.views.claim-detail.Account',
        defaultMessage: 'Account'
    },
    dateOfLossClaimDetail: {
        id: 'portal.claim.views.claim-detail.Date of Loss',
        defaultMessage: 'Date of Loss'
    },
    totalPayments: {
        id: 'portal.claim.views.claim-detail.Paid',
        defaultMessage: 'Paid'
    },
    totalIncurrednet: {
        id: 'portal.claim.views.claim-detail.Net Incurred',
        defaultMessage: 'Net Incurred'
    },
    adjusterTitle: {
        id: 'portal.claim.views.claim-detail.Adjuster',
        defaultMessage: 'Adjuster'
    },
    adjusterName: {
        id: 'portal.claim.views.claim-detail.Name',
        defaultMessage: 'Name'
    },
    adjusterPhone: {
        id: 'portal.claim.views.claim-detail.Phone',
        defaultMessage: 'Phone'
    },
    adjusterAddnoteButton: {
        id: 'portal.claim.views.claim-detail.Add Note',
        defaultMessage: 'Add Note'
    },
    addnoteButton: {
        id: 'portal.claim.views.claim-detail.Note',
        defaultMessage: 'Note'
    },
    partiesInvolved: {
        id: 'portal.claim.views.claim-detail.Parties Involved',
        defaultMessage: 'Parties Involved'
    },
    vendorsInvolved: {
        id: 'portal.claim.views.claim-detail.Vendors involved',
        defaultMessage: 'Vendors Involved'
    },
    involvement: {
        id: 'portal.claim.views.claim-detail.Involvement',
        defaultMessage: 'Involvement'
    },
    vehicle: {
        id: 'portal.claim.views.claim-detail.Vehicle(s)',
        defaultMessage: 'Vehicle(s)'
    },
    make: {
        id: 'portal.claim.directives.pa-vehicle-coverages.Make',
        defaultMessage: 'Make'
    },
    model: {
        id: 'portal.claim.directives.pa-vehicle-coverages.Model',
        defaultMessage: 'Model'
    },
    year: {
        id: 'portal.claim.directives.pa-vehicle-coverages.Year',
        defaultMessage: 'Year'
    },
    license: {
        id: 'portal.claim.directives.pa-vehicle-coverages.License #',
        defaultMessage: 'License #'
    },
    coveragesFor: {
        id: 'portal.claim.directives.pa-vehicle-coverages.Coverages for',
        defaultMessage: 'Coverages for {vehicleMake} {vehicleModel}'
    },
    type: {
        id: 'portal.claim.directives.pa-vehicle-coverages.Type',
        defaultMessage: 'Type'
    },
    deductible: {
        id: 'portal.claim.directives.pa-vehicle-coverages.Deductible',
        defaultMessage: 'Deductible'
    },
    limittype: {
        id: 'portal.claim.directives.pa-vehicle-coverages.Limit Type',
        defaultMessage: 'Limit Type'
    },
    limitvalue: {
        id: 'portal.claim.directives.pa-vehicle-coverages.Limit Value',
        defaultMessage: 'Limit Value'
    },
    perAccident: {
        id: 'portal.claim.directives.pa-vehicle-coverages.Per Accident',
        defaultMessage: 'Per Accident'
    },
    perPerson: {
        id: 'portal.claim.directives.pa-vehicle-coverages.Per Person',
        defaultMessage: 'Per Person'
    },
    lossLocation: {
        id: 'portal.claim.views.claim-detail.Loss Location',
        defaultMessage: 'Loss Location'
    },
    employerNotified: {
        id: 'portal.claim.views.claim-detail.Date Employer Notified',
        defaultMessage: 'Date Employer Notified'
    },
    daysInHospital: {
        id: 'portal.claim.views.claim-detail.Hospital',
        defaultMessage: 'Days spent in the hospital'
    },
    noNotes: {
        id: 'portal.claim.views.claim-detail.No notes associated with this claim',
        defaultMessage: 'There are no notes associated with this claim.'
    },
    notesAuthor: {
        id: 'portal.claim.directives.claim-notes.Author',
        defaultMessage: 'Author'
    },
    notesDate: {
        id: 'portal.claim.directives.claim-notes.Date / Time',
        defaultMessage: 'Date / Time'
    },
    notesSubject: {
        id: 'portal.claim.directives.claim-notes.Subject',
        defaultMessage: 'Subject'
    },
    notesContent: {
        id: 'portal.claim.directives.claim-notes.Note',
        defaultMessage: 'Note'
    },
    searchPlaceholder: {
        id: 'portal.claim.directives.claim-notes.Search',
        defaultMessage: 'Search'
    },
    createNoteSubject: {
        id: 'portal.claim.views.create-note.Subject',
        defaultMessage: 'Subject'
    },
    createNoteCancel: {
        id: 'portal.claim.views.create-note.Cancel',
        defaultMessage: 'Cancel'
    },
    createNoteSave: {
        id: 'portal.claim.views.create-note.Save',
        defaultMessage: 'Save'
    },
    documentsName: {
        id: 'portal.claim.directives.claim-documents.Name',
        defaultMessage: 'Name'
    },
    documentsDateModified: {
        id: 'portal.claim.directives.claim-documents.Date Modified',
        defaultMessage: 'Date Modified'
    },
    documentsViewandDownload: {
        id: 'portal.claim.directives.claim-documents.View/Download',
        defaultMessage: 'View/Download'
    },
    documentsRemove: {
        id: 'portal.claim.directives.claim-documents.Remove',
        defaultMessage: 'Remove'
    },
    uploadDocuments: {
        id: 'portal.platform.documentupload.templates.document-upload.Upload Documents',
        defaultMessage: 'Upload Documents'
    },
    modalAddress: {
        id: 'portal.platform.contacts.templates.contact-template.Address',
        defaultMessage: 'Address'
    },
    modalPrimary: {
        id: 'portal.platform.contacts.templates.contact-template.primary',
        defaultMessage: 'primary'
    },
    modalPrimaryContact: {
        id: 'portal.platform.contacts.templates.contact-template.Primary Contact',
        defaultMessage: 'Primary Contact'
    },
    modalPhoneNumber: {
        id: 'portal.platform.contacts.templates.contact-template.Phone Number',
        defaultMessage: 'Phone Number'
    },
    modalFaxNumber: {
        id: 'portal.platform.contacts.templates.contact-template.Fax Number',
        defaultMessage: 'Fax Number'
    },
    modalClose: {
        id: 'portal.platform.contacts.templates.contact-template.Close',
        defaultMessage: 'Close'
    },
    modalUnknown: {
        id: 'portal.platform.contacts.Unknown',
        defaultMessage: 'Unknown'
    },
    claimServicesMessage: {
        id: 'portal.claim.views.claim-detail.This tab contains claim-related services such as repairs, replacements or medical treatments.',
        defaultMessage: 'This tab contains claim-related services such as repairs, replacements or medical treatments.',
    },
    statusInProgress: {
        id: 'portal.claim.views.claim-detail.In Progress',
        defaultMessage: 'In Progress',
    },
    statusCompleted: {
        id: 'portal.claim.views.claim-detail.Completed',
        defaultMessage: 'Completed',
    },
    statusOffTrack: {
        id: 'portal.claim.views.claim-detail.Off Track',
        defaultMessage: 'Off Track',
    },
    statusUnknown: {
        id: 'portal.claim.controllers.ClaimDetailsCtrl.Unknown',
        defaultMessage: 'Unknown',
    },
    serviceNumber: {
        id: 'portal.claim.views.claim-detail.Service Number',
        defaultMessage: 'Service Number',
    },
    nextAction: {
        id: 'portal.claim.views.claim-detail.Next Action',
        defaultMessage: 'Next Action',
    },
    service: {
        id: 'portal.claim.views.claim-detail.Service',
        defaultMessage: 'Service',
    },
    vendor: {
        id: 'portal.claim.views.claim-detail.Vendor',
        defaultMessage: 'Vendor',
    },
    expectedCompletionDate: {
        id: 'portal.claim.views.claim-detail.Expected Completion Date',
        defaultMessage: 'Expected Completion Date',
    },
    primaryContact: {
        id: 'portal.claim.views.claim-detail.Primary Contact',
        defaultMessage: 'Primary Contact',
    },
    noClaimServices: {
        id: 'portal.claim.views.claim-detail.There are no service requests associated with this claim.',
        defaultMessage: 'There are no service requests associated with this claim.',
    },
    paymentServicesMessage: {
        id: 'portal.claim.directives.claim-payment-details.This tab lists payment transactions made based on the claim.',
        defaultMessage: 'This tab lists payment transactions made based on the claim.',
    },
    paymentStatus: {
        id: 'portal.claim.directives.claim-payment-details.Status',
        defaultMessage: 'Status',
    },
    scheduledDate: {
        id: 'portal.claim.directives.claim-payment-details.Scheduled Date',
        defaultMessage: 'Scheduled Date',
    },
    issueDate: {
        id: 'portal.claim.directives.claim-payment-details.Issue Date',
        defaultMessage: 'Issue Date',
    },
    grossAmount: {
        id: 'portal.claim.directives.claim-payment-details.Gross Amount',
        defaultMessage: 'Gross Amount',
    },
    checkNumber: {
        id: 'portal.claim.directives.claim-payment-details.Check Number',
        defaultMessage: 'Check Number',
    },
    payee: {
        id: 'portal.claim.directives.claim-payment-details.Payee',
        defaultMessage: 'Payee',
    },
    noClaimPayments: {
        id: 'portal.claim.directives.claim-payment-details.There are no payments associated with this claim issued within the last 90 days.',
        defaultMessage: 'There are no payments associated with this claim issued within the last 90 days.',
    },
    confirmationToRemoveTitle: {
        id: 'portal.claim.directives.ClaimDocuments.Remove Document',
        defaultMessage: 'Remove Document'
    },
    confirmationToRemoveMessage: {
        id: 'portal.claim.directives.ClaimDocuments.Are you sure you want to remove',
        defaultMessage: 'Are you sure you want to remove {documentname}?'
    },
    removeConfirmationYes: {
        id: 'portal.claim.directives.ClaimDocuments.Yes',
        defaultMessage: 'Yes'
    },
    removeConfirmationNo: {
        id: 'portal.claim.directives.ClaimDocuments.No',
        defaultMessage: 'No'
    },
    deletionFailedTitle: {
        id: 'portal.claim.directives.ClaimDocuments.Document deletion may have failed',
        defaultMessage: 'Document deletion may have failed'
    },
    deletionFailedMessage: {
        id: 'portal.claim.directives.ClaimDocuments.Something may have gone wrong trying to delete your document.',
        defaultMessage: 'Something may have gone wrong trying to delete your document.'
    },
    removeServiceFailedTitle: {
        id: 'portal.claim.directives.ClaimDocuments.Document deletion failed',
        defaultMessage: 'Document deletion failed'
    },
    removeServiceFailedMessage: {
        id: 'portal.claim.directives.ClaimDocuments.Sorry your document could not be deleted at this time',
        defaultMessage: 'Sorry your document could not be deleted at this time'
    },
    noDocumentsMessage: {
        id: 'portal.claim.directives.claim-documents.There are no documents associated with this claim.',
        defaultMessage: 'There are no documents associated with this claim.'
    },
    claimsTitle: {
        id: 'portal.claim.views.claims.Claims',
        defaultMessage: 'Claims'
    },
    line: {
        id: 'portal.claim.views.claims-list.Line',
        defaultMessage: 'Line'
    },
    claimNumber: {
        id: 'portal.claim.views.claims-list.Claim Number',
        defaultMessage: 'Claim Number'
    },
    claimVendors: {
        id: 'portal.claim.views.claims-list.Vendors',
        defaultMessage: 'Vendor(s)'
    },
    claimStatus: {
        id: 'portal.claim.views.claims-list.Status',
        defaultMessage: 'Status'
    },
    closedClaims: {
        id: 'portal.claim.views.claims-list.Closed Claims',
        defaultMessage: 'Closed Claims'
    },
    includeClosedClaims: {
        id: 'portal.claim.views.claims-list.Include Closed Claims',
        defaultMessage: 'Include Closed Claims'
    },
    allClaims: {
        id: 'portal.claim.views.claims-list.All Claims',
        defaultMessage: 'All Claims'
    },
    filters: {
        id: 'portal.claim.views.claims-list.Filters',
        defaultMessage: 'Filters'
    },
    filterBy: {
        id: 'portal.claim.views.claims-list.Filter By',
        defaultMessage: 'Filter By'
    },
    noClaimsResult: {
        id: 'portal.claim.views.claims-list.No Claims',
        defaultMessage: 'There are no claims currently active'
    },
    fileWCclaim: {
        id: 'ext.portal.claim.views.claims-list.File a WC Claim',
        defaultMessage: 'File a Claim for Workers\' Comp'
    },
    fileWCclaim: {
        id: 'ext.portal.claim.views.claims-list.File a Non WC Claim',
        defaultMessage: 'File a Claim for Other Lines/Non-Work Comp'
    },
    unableToDeleteClaims: {
        id: 'portal.claim.directives.ClaimDocuments.Unable to delete that document',
        defaultMessage: 'Unable to delete {documentName}'
    },
    loadingPolicyDetails: {
        id: 'portal.claim.views.claim-policy-details.Loading policy details..',
        defaultMessage: 'Loading policy details..'
    },
    errorLoadingPolicyDetails: {
        id: 'portal.claim.views.claim-policy-details.Error loading policy details...',
        defaultMessage: 'Error loading policy details...'
    },
    claimPolicyDetails: {
        id: 'portal.claim.views.claim-policy-details.Policy Details',
        defaultMessage: 'Policy Details : {policyNumber}'
    },
    claimVehicleCoverage: {
        id: 'portal.claim.views.claim-policy-details.Vehicle Coverages',
        defaultMessage: 'Vehicle Coverages'
    },

    policyLevelCoverages: {
        id: 'portal.claim.directives.policy-level-coverages.Policy-Level Coverages',
        defaultMessage: 'Policy-Level Coverages'
    },
    limitType: {
        id: 'portal.claim.directives.policy-level-coverages.Limit Type',
        defaultMessage: 'Limit Type'
    },
    limitValue: {
        id: 'portal.claim.directives.policy-level-coverages.Limit Value',
        defaultMessage: 'Limit Value'
    },
    coverage: {
        id: 'portal.claim.directives.policy-level-coverages.Coverage',
        defaultMessage: 'Coverage'
    },
    coveragePerAccident: {
        id: 'portal.claim.directives.policy-level-coverages.Per Accident',
        defaultMessage: 'Per Accident'
    },
    coveragePerPerson: {
        id: 'portal.claim.directives.policy-level-coverages.Per Person',
        defaultMessage: 'Per Person'
    },
    limit: {
        id: 'portal.claim.directives.policy-level-coverages.Limit',
        defaultMessage: 'Limit'
    },
    insured: {
        id: 'portal.claim.views.claim-detail.Insured',
        defaultMessage: 'Insured '
    },
    createNoteErrorTitle: {
        id: 'portal.claim.controllers.CreateNoteCtrl.Claim update failed',
        defaultMessage: 'Claim update failed'
    },
    createNoteErrorMessage: {
        id: 'portal.controllers.CreateNoteCtrl.Sorry, we were not able to add a new note to your claim.',
        defaultMessage: 'Sorry, we were not able to add a new note to your claim.'
    },
    claimHistoryTitle: {
        id: 'portal.claim.views.claim-detail.claim.views.claim-detail.Request Claims History Confirmation',
        defaultMessage: 'Request Claims History Confirmation'
    },
    claimHistoryMessage: {
        id: 'portal.claim.views.claim-detail.claim.views.claim-detail.The claims history will be sent to',
        defaultMessage: 'The claims history document will be sent to {email} within 24 hours. After the request is confirmed, the claims history request button will be unavailable for 24 hours.'
    },
    claimExtractTitle: {
        id: 'portal.claim.views.claim-detail.claim.views.claim-detail.Request Detail Loss Extract Confirmation',
        defaultMessage: 'Request Detail Loss Extract Confirmation'
    },
    claimExtractMessage: {
        id: 'portal.claim.views.claim-detail.claim.views.claim-detail.The claims extract will be sent to',
        defaultMessage: 'The detail loss extract will be sent to {email} within 24 hours. After the request is confirmed, the detail loss extract request link will be unavailable for 24 hours.'
    },
    ClaimStatusTitle:{
        id: 'portal.claim.views.claim-detail.claim.views.claim-detail.Claims Status Report Request Confirmation',
        defaultMessage: 'Claims Status Report Request Confirmation'
    },
    ClaimStatus:{
        id: 'portal.claim.views.claim-detail.claim.views.claim-detail.Claim Status report sent to',
        defaultMessage: 'The Claim Status Report will be sent to {email} within 24 hours. After the request is confirmed, the Request Claim Status link will be unavailable for 24 hours.'
    },
    claimHistoryConfirm: {
        id: 'portal.claim.views.claim-detail.claim.views.claim-detail.Confirm',
        defaultMessage: 'Confirm'
    },
    claimHistoryCancel: {
        id: 'portal.claim.views.claim-detail.claim.views.claim-detail.Cancel',
        defaultMessage: 'Cancel'
    },
    claimLossTitle: {
        id: 'portal.claim.views.claim-detail.claim.views.claim-detail.Loss Run Request Confirmation',
        defaultMessage: 'Loss Run Request Confirmation'
    },
    claimLossMessage: {
        id: 'portal.claim.views.claim-detail.claim.views.claim-detail.The loss history document will be sent to',
        defaultMessage: 'The loss history document will be sent to {email} within 24 hours. After the request is confirmed, the loss run request button will be unavailable for 24 hours.'
       
    },
    removeClaim: {
        id: 'portal.claim.views.claim-detail.claim.views.claim-detail.Confirm Draft Claim Deletion',
        defaultMessage: 'Confirm Draft Claim Deletion'
       
    },
    confirmRemoveClaim: {
        id: 'portal.claim.views.claim-detail.claim.views.claim-detail.Are you sure you want to delete the selected draft claim',
        defaultMessage: 'Are you sure you want to delete the selected draft claim ?'
       
    },
    claimRemoveConfirmYes: {
        id: 'portal.claim.views.claim-detail.claim.views.claim-detail.Yes',
        defaultMessage: 'Yes'
       
    },
    claimRemoveConfirmNo: {
        id: 'portal.claim.views.claim-detail.claim.views.claim-detail.No',
        defaultMessage: 'No'
       
    },
    ClaimAnalysisTitle:{
        id: 'portal.claim.views.claim-detail.claim.views.claim-detail.Claims Analysis Report Request Confirmation',
        defaultMessage: 'Claims Analysis Report Request Confirmation'
    },
    ClaimAnalysis:{
        id: 'portal.claim.views.claim-detail.claim.views.claim-detail.The Claim Analysis Report (CAR) will be sent to',
        defaultMessage: 'The Claim Analysis Report (CAR) will be sent to {email} within 24 hours. After the request is confirmed, the CAR link will be unavailable for 24 hours.'
    },
    ClaimSearchInputPlaceholder:{
        id: 'portal.claim.views.claims-list.search.Search by Claim #, Policy #, or Claimant Name',
        defaultMessage: 'Search by Claim #, Policy #, or Claimant Name'
    },
    ClaimSearchNoResultsText:{
        id: 'claim.views.claims-list.No results were found for this filter.',
        defaultMessage: 'No results were found for this filter.'
    },
});
